<template>
	<div class="form-group" :class="[componentClass, activeClass]">
		<validation-provider v-slot="{ classes }" :rules="rules">
			<label v-if="showLabel" :for="name" class="inline-block with-margin-top-15">
				{{ $t(label) }}{{ requiredMark }}
			</label>

			<vue-select
				:id="name"
				class="ius-dropdown"
				:placeholder="placeholderTextToUse"
				:name="name"
				:class="classes"
				:value="selected"
				:options="items"
				:reduce="(item) => item.id"
				:filterable="false"
				:searchable="false"
				@input="updateSelected"
			>
				<template #option="option">
					{{ option.label }}
				</template>
			</vue-select>
		</validation-provider>
	</div>
</template>

<script>
import { VueSelect } from 'vue-select'
import Helpers from '@/mixins/Helpers'

export default {
	name: 'FormDropdown',
	components: {
		VueSelect,
	},
	mixins: [Helpers],
	props: {
		componentClass: {
			type: String,
			default: '',
		},
		forceRequiredMark: {
			type: Boolean,
			default: false,
		},
		inputUpdatedEventName: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
		placeholderText: {
			type: String,
			default: '',
		},
		rules: {
			type: String,
			default: '',
		},
		selected: {
			type: [String, Number],
			default: '',
		},
	},
	computed: {
		activeClass() {
			return this.selected || this.selected === 0 ? 'field-active' : ''
		},
		placeholderTextToUse() {
			return this.placeholderText ? this.placeholderText : this.$t('Misc.Choose')
		},
	},
	methods: {
		updateSelected(selected) {
			// Emit input updated event
			if (this.inputUpdatedEventName) {
				this.$root.$emit(this.inputUpdatedEventName, {
					value: selected,
				})

				// Removed for unexpected mutation of "selected" prop
				// this.selected = selected
			}
		},
	},
}
</script>

<style src="vue-select/dist/vue-select.css"></style>



// WEBPACK FOOTER //
// src/components/atoms/FormDropdown.vue